__webpack_require__.p = "https://webapp-static.ca-kijiji-production.classifiedscloud.io/1.40.11/_next/";